import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import Zoom from "react-medium-image-zoom";
import { getParticularProductDetails } from "./../api/index";
import { getBackendAssetsUrl } from "./../config/Production";
import DOMPurify from "dompurify";
import { addToCartLocal } from "./../config/commonfunctions/AddToCart";
// COMPONENT FOR RENDERING PRODUCTS PRICING AND DECIDING ITS LAYOUT FROM ONE PLACE
import ProductPricing from "./Components/ProductPricing";

// global imports (once)
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-medium-image-zoom/dist/styles.css";

export default function DetailedProduct() {
  const { slug } = useParams();
  const [foldername, setFolderName] = useState("");
  const [backurl, setBackUrl] = useState("");
  const [product, setProduct] = useState([]);
  const [prodimages, setProdImages] = useState([]);
  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    const getParticularProduct = async () => {
      try {
        const response = await getParticularProductDetails({ slug });
        setProduct(response.data.SingleProduct);
        setProdImages(response.data.SingleProduct.product_images.split("|"));
        setFolderName(
          response.data.SingleProduct.product_name
            .replaceAll(" ", "_")
            .toLowerCase(),
        );
      } catch (err) {
        console.error(err);
      }
    };
    setBackUrl(getBackendAssetsUrl());
    getParticularProduct();
  }, []);
  return (
    <section className="prt-row product-detail-section clearfix">
      <div className="container">
        <div className="row align-items-start">
          {/* LEFT – Image Slider */}
          <div className="col-lg-6 mb-30">
            <div className="product-gallery">
              <Slider {...sliderSettings}>
                {prodimages.map((img, i) => (
                  <div key={i} className="product-image-slide">
                    <Zoom>
                      <img
                        src={`${backurl}shop_product_listing/${foldername}/${img}_large.webp`}
                        alt={img}
                        className="detailed-page-image img-fluid border-rad_20"
                        style={{ cursor: "zoom-in" }}
                      />
                    </Zoom>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          {/* RIGHT – Product Info */}
          <div className="col-lg-6">
            <div className="product-summary">
              <h2 className="product-title mb-10">{product.product_name}</h2>

              <p className="product-short-desc mb-15">
                {product.shortDescription}
              </p>
              <div className="product-meta mb-20">
                <p>
                  <b>Main Category:</b> {product?.maincategory?.category_code}
                </p>
                <p>
                  <b>Sub Category:</b> {product?.subcategory?.category_code}
                </p>
                <p>
                  <b>Availability:</b> In Stock
                </p>
              </div>

              <div className="product-price mb-20">
                {/* <span className="old-price mr-10">₹{product.oldPrice}</span> */}
                <span className="new-price">
                  <ProductPricing ProductPrice={product.price} />
                </span>
              </div>

              <div className="product-actions d-flex align-items-center">
                <input
                  type="number"
                  min="1"
                  defaultValue="1"
                  className="form-control w-25 mr-15"
                />

                <button
                  className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-skincolor mr-10"
                  onClick={() => addToCartLocal(product)}
                >
                  Add to Cart
                </button>

                <button className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor">
                  Buy Now
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Description Section */}
        <div className="row mt-50">
          <div className="col-lg-12">
            <div className="section-title mb-20">
              <h3>Product Description</h3>
            </div>

            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(product.short_description),
              }}
            ></p>
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(product.long_description),
              }}
            ></p>
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(product.specifications),
              }}
            ></p>
          </div>
        </div>
      </div>
    </section>
  );
}
